<template>
  <div class="description-tab">
    <div
      class="description-tab__header"
      v-if="metadata && metadata.top_custom_panels"
    >
      <div
        class="header-top flex-row"
        v-if="!hidden(metadata.top_custom_panels.name)"
      >
        <p class="vacancy-name">
          {{
            metadata.top_custom_panels.name &&
            metadata.top_custom_panels.name.value
              ? formatHtml(metadata.top_custom_panels.name.value)
              : 'Нет наименования'
          }}
        </p>
        <p
          class="description-text description-text--grey"
          v-if="!hidden(metadata.top_custom_panels.last_activity_date)"
        >
          {{
            `Последняя активность: ${
              metadata.top_custom_panels.last_activity_date &&
              metadata.top_custom_panels.last_activity_date.value
                ? formatHtml(
                    metadata.top_custom_panels.last_activity_date.value
                  )
                : 'неизвестно'
            }`
          }}
        </p>
      </div>
      <div class="header-center flex-row">
        <div class="flex-row">
          <span
            v-if="
              metadata.top_custom_panels.hrpac_vacancy_user_name &&
              !metadata.top_custom_panels.hrpac_vacancy_user_name?.visibility
            "
            contenteditable
            type="text"
            class="vacancy-label description-text description-text--grey"
            @keydown="inputHandler"
            @blur="userFieldHandler"
            @paste="pasteHandle"
            v-html="
              $sanitize(
                metadata.top_custom_panels.hrpac_vacancy_user_name.value
              )
            "
          >
          </span>
          <Icon
            v-if="
              metadata.top_custom_panels.hrpac_vacancy_user_name &&
              !metadata.top_custom_panels.hrpac_vacancy_user_name?.visibility
            "
            iconName="pen_16"
            iconColor="#788694"
            class="header-center__icon"
          />
        </div>

        <p
          class="header-center__tag"
          v-if="
            !hidden(
              metadata.top_custom_panels.hrpac_vacancy_difficulty_level_name
            ) &&
            metadata.top_custom_panels.hrpac_vacancy_difficulty_level_name &&
            metadata.top_custom_panels.hrpac_vacancy_difficulty_level_name.value
          "
        >
          {{
            formatHtml(
              metadata.top_custom_panels.hrpac_vacancy_difficulty_level_name
                .value
            )
          }}
        </p>
      </div>
      <div class="header-bottom flex-row">
        <div
          class="header-bottom__item flex-row"
          v-if="
            metadata.top_custom_panels.vacancy_number?.value ||
            metadata.top_custom_panels.coordination_requests_number?.value
          "
        >
          <Icon iconName="Id" iconColor="#788694" />
          <p class="description-text">
            {{
              formatHtml(
                metadata.top_custom_panels.vacancy_number?.value ||
                  metadata.top_custom_panels.coordination_requests_number?.value
              )
            }}
          </p>
        </div>
        <div
          class="header-bottom__item flex-row"
          v-if="
            (metadata.top_custom_panels.location_id &&
              !metadata.top_custom_panels.location_id.visibility) ||
            (metadata.top_custom_panels.location_id &&
              metadata.top_custom_panels.location_id.visibility &&
              metadata.top_custom_panels.location_id.visibility !== 'hidden')
          "
        >
          <Icon iconName="Pin" iconColor="#788694" />
          <p class="description-text">
            {{
              metadata.top_custom_panels.location_id &&
              metadata.top_custom_panels.location_id.value
                ? formatHtml(metadata.top_custom_panels.location_id.value)
                : 'не указано'
            }}
          </p>
        </div>
        <div
          class="header-bottom__item flex-row"
          v-if="
            !hidden(metadata.top_custom_panels.amount_final) &&
            !hidden(metadata.top_custom_panels.amount)
          "
        >
          <Icon iconName="UserPass" iconColor="#788694" />
          <p class="description-text">
            {{
              metadata.top_custom_panels.amount_final &&
              metadata.top_custom_panels.amount_final.value
                ? formatHtml(metadata.top_custom_panels.amount_final.value)
                : metadata.top_custom_panels.amount?.value
                ? formatHtml(metadata.top_custom_panels.amount.value)
                : 'не указано'
            }}
          </p>
        </div>
        <div
          class="header-bottom__item flex-row"
          v-if="
            (metadata.top_custom_panels.reason_for_opening &&
              !metadata.top_custom_panels.reason_for_opening.visibility) ||
            (metadata.top_custom_panels.reason_for_opening &&
              metadata.top_custom_panels.reason_for_opening.visibility &&
              metadata.top_custom_panels.reason_for_opening.visibility !==
                'hidden')
          "
        >
          <Icon iconName="Duitcase" iconColor="#788694" />
          <p class="description-text" :title="formatHtml('') || ''">
            {{
              metadata.top_custom_panels.reason_for_opening &&
              metadata.top_custom_panels.reason_for_opening.value
                ? formatHtml(
                    metadata.top_custom_panels.reason_for_opening.value
                  )
                : 'не указано'
            }}
          </p>
        </div>
        <div
          class="header-bottom__item flex-row"
          v-if="!metadata.top_custom_panels.job_mode_group?.visibility"
        >
          <Icon iconName="Globe" iconColor="#788694" />
          <p class="description-text" :title="formatHtml('') || ''">
            {{
              metadata.top_custom_panels.job_mode_group &&
              metadata.top_custom_panels.job_mode_group.value
                ? formatHtml(metadata.top_custom_panels.job_mode_group.value)
                : 'не указано'
            }}
          </p>
        </div>
      </div>
    </div>
    <div
      class="description-tab__panels"
      v-if="!!metadata && !!metadata.panels && metadata.panels.length"
    >
      <DetailViewGroupFields
        v-for="item in metadata.panels"
        :key="item.panel_id"
        :panel="item"
        :fields="metadata.bean"
        store-module="candidate"
      />
    </div>
  </div>
</template>
<script>
import { postController } from '@/controllers/request.js';
import { mixin, form } from '@/utils/mixins';
import DetailViewGroupFields from 'Elements/MetaData/DetailViewGroupFields';
import { MODULE, ACTION } from '@/utils/constants';

import Icon from 'Elements/Icon/Icon';

export default {
  mixins: [mixin, form],
  props: {
    fields: {
      type: Object,
      default() {
        return {};
      }
    },
    metadata: Object,
    data: Object
  },
  data() {
    return {
      name: 'Технический архитектор в базы данных',
      date: '10.06.2022',
      sec_name: 'ВТБ Лизинг',
      location: 'Балашиха',
      type: 'Базовая вакансия',
      num: 10,
      reason: 'Новый сотрудник',
      work_type: 'удаленная работа'
    };
  },
  methods: {
    tags(data) {
      return data.value ? data.value.split(/,\s*/g) : [];
    },
    pasteHandle(e) {
      if (e.target.outerText.length > 98) {
        e.preventDefault();
        e.target.outerText = e.target.outerText.slice(0, 97);
      }
    },
    inputHandler(e) {
      //если длина пользовательского наименование больше 98 и нажата любая
      //кнопка кроме Enter\Return, Backspace, Delete и боковых стрелок - блокируем ввод
      if (
        (e.target.outerText.length + 1 > 98 &&
          ![8, 46, 37, 39].includes(e.keyCode)) ||
        e.keyCode == 13
      ) {
        e.preventDefault();
      }
    },
    async userFieldHandler(e) {
      const options = new FormData();

      options.append('module', MODULE.VACANCY_MODULE);
      options.append('action', ACTION.SAVE);
      options.append('hrpac_vacancy_user_name', e.target.innerText.trim());
      options.append('record', this.$route.params.id);
      options.append('jsqon_return', 1);

      try {
        const response = await postController({ options });
        if (response.data.status && response.data.status == 'ok') {
          this.$emit('reloadTab');
        }
      } catch (err) {
        this.catchError(err, 'Возникла ошибка sаve');
      }
    }
  },
  components: { Icon, DetailViewGroupFields }
};
</script>

<style lang="scss" scoped>
.description-tab {
  border-radius: 4px;
  background: $white;
  text-align: left;
  padding-bottom: 16px;

  &__header {
    padding: 24px;
    border-bottom: 1px solid $grey8;

    .header-center {
      margin-bottom: 16px;
      align-items: end;
      justify-content: space-between;

      div {
        align-items: center;
      }

      &__icon {
        width: 16px;
        height: 16px;
      }

      .vacancy-label {
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        outline: none;
        min-width: 30px;

        &:empty:not(:focus):not(:hover):before {
          content: 'Введите';
          color: $red;
          display: block;
        }

        &:empty:hover:before {
          content: 'Введите';
          color: $red;
          display: block;
        }
      }

      &__tag {
        padding: 0px 4px;
        background: $grey12;
        border-radius: 4px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        height: 20px;
        color: $grey64;
        white-space: nowrap;
      }
    }

    .header-top {
      margin-bottom: 8px;
      justify-content: space-between;

      .vacancy-name {
        font-size: 24px;
        line-height: 28px;
        display: flex;
        max-width: 546px;
        color: #21272c;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    .header-bottom {
      display: inline;

      &__item {
        margin-right: 32px;
        width: fit-content;

        .description-text {
          padding-left: 4px;
        }
      }
    }
  }

  &__panels {
    padding: 8px 24px;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .description-text {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    color: $grey80;

    &--grey {
      color: $grey64;
    }
  }
}
</style>
